import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { HttpHelper } from 'rbh-merchant-core';

// Init http instance once
HttpHelper.createInstance({
  // Default axios configuration
});

ReactDOM.render(<App />, document.getElementById('root'));
